import React from "react";

export const View = () => {
	return (
		<div>
			<div>
				<h1>404 page not found</h1>
			</div>
		</div>
	);
};
